import React from 'react';
import { FrontSkeletonLine, FrontShimmer } from '../../../ips-react-front-fw/components/shimmer';

type Props = {
  rows?: number;
};

export const AddressFormSkeleton: React.FC<Props> = ({ rows = 7 }) => {
  const items = Array.from({ length: rows }, (_, i) => i);

  return (
    <div className="ips-front-address-skeleton" aria-hidden="true">
      {items.map((idx) => (
        <div className="ips-front-address-skeleton__row" key={idx}>
          <FrontSkeletonLine
            width={idx % 3 === 0 ? '36%' : '42%'}
            className="ips-front-address-skeleton__label"
          />
          <FrontShimmer height={44} className="ips-front-address-skeleton__input" />
        </div>
      ))}
      <div className="ips-front-address-skeleton__footer">
        <FrontShimmer width={110} height={40} className="ips-front-address-skeleton__button" />
        <FrontShimmer width={132} height={40} className="ips-front-address-skeleton__button" />
      </div>
    </div>
  );
};
